import {
  progress_card_styles_default
} from "./chunk.NCCYI7R4.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/progress-card/progress-card.ts
var FadvProgressCard = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "icon");
    this.heading = "";
    this.value = 0;
    this.variant = "primary";
    this.hideProgressBar = false;
  }
  render() {
    return $`<div part="base" class="progress-card" class=${o({
      "progress-card": true,
      "progress-card--hide-progress-bar": this.hideProgressBar,
      "progress-card--has-icon": this.hasSlotController.test("icon"),
      "progress-card--primary": this.variant === "primary",
      "progress-card--secondary": this.variant === "secondary",
      "progress-card--tertiary": this.variant === "tertiary",
      "progress-card--neutral": this.variant === "neutral",
      "progress-card--success": this.variant === "success",
      "progress-card--warning": this.variant === "warning",
      "progress-card--danger": this.variant === "danger"
    })} ><div class="progress-card__container"><div class="progress-card__icon"><slot name="icon"></slot></div><div class="progress-card__progress"><div class="progress-card__body"><fadv-typography class="progress-card__heading" type="label-medium" weight="500">${this.heading}</fadv-typography><fadv-typography class="progress-card__percentage" type="heading-large" weight="500">${this.value}%</fadv-typography></div><span class="progress-card__content"><slot></slot></span></div><div class="progress-card__progress-bar"><fadv-progress-bar variant="${this.variant}" value="${this.value}" label="${this.heading}"></fadv-progress-bar></div></div></div>`;
  }
};
FadvProgressCard.styles = progress_card_styles_default;
__decorateClass([
  e({ type: String, reflect: true })
], FadvProgressCard.prototype, "heading", 2);
__decorateClass([
  e({ type: Number, reflect: true })
], FadvProgressCard.prototype, "value", 2);
__decorateClass([
  e({ reflect: true })
], FadvProgressCard.prototype, "variant", 2);
__decorateClass([
  e({ attribute: "hide-progress-bar", type: Boolean, reflect: true })
], FadvProgressCard.prototype, "hideProgressBar", 2);
FadvProgressCard = __decorateClass([
  n("fadv-progress-card")
], FadvProgressCard);

export {
  FadvProgressCard
};
